module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1006-702115ac4acd85163ba1cea2ce68c0c4.png";